import { render, staticRenderFns } from "./AddPPPage.vue?vue&type=template&id=bf7ccf94&scoped=true&"
import script from "./AddPPPage.vue?vue&type=script&lang=js&"
export * from "./AddPPPage.vue?vue&type=script&lang=js&"
import style0 from "./AddPPPage.vue?vue&type=style&index=0&id=bf7ccf94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf7ccf94",
  null
  
)

export default component.exports